<template>
  <div class="container">
    <div class="flex">
      <div class="title">原密码</div>
      <el-input
        v-model="pwd1"
        clearable
        placeholder="请输入原密码"
        type="text"
      />
    </div>
    <div class="flex">
      <div class="title">新密码</div>
      <el-input
        v-model="pwd2"
        clearable
        placeholder="请输入新密码"
        type="text"
      />
    </div>
    <div class="flex btn-container">
      <el-button
        class="btn"
        type="danger"
        style="background-color: #f42434"
        @click="send"
        >确认</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pwd1: "",
      pwd2: "",
    };
  },
  methods: {
    send() {
      if (!this.pwd1) {
        this.$alert("请输入原密码", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (!this.pwd2) {
        this.$alert("请输入新密码", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$axios
        .postReq("/meide/REST/ajaxSelectProduct", {
          postType: "changePassword",
          password: this.pwd1,
          type: "check",
        })
        .then((res) => {
          let pwdFlag = res.pwdFlag;

          if (!pwdFlag) {
            this.$alert("原密码输入错误", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
         this.$axios
         
        .postReq("/meide/REST/ajaxSelectProduct", {
         postType: "changePassword",
            password: this.pwd2,
            type: "change",
        })
          .then((res2) => {
            if (res2.success == "true") {
              this.$message.success("修改成功!");
              this.pwd1 = "";
              this.pwd2 = "";
            } else {
              this.$alert("修改失败", "提示", {
                confirmButtonText: "确定",
              });
            }
          });
        });
    },
  },
};
</script>

<style lang="scss">
.container {

   .el-input__inner {

    -webkit-text-security:disc!important;

  }

}
</style>
<style lang="scss" scoped>

.container {
//   padding: 20px;
  padding-top: 20px;
  width: 600px;
  box-sizing: border-box;
}
.flex {
  width: 500px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .title {
    width: 80px;
    text-align: left;
    margin-right: 20px;
  }
}
.btn-container {
  margin-top: 50px;
  position: relative;
  .btn {
    position: absolute;
    right: 0;
  }
}
</style>